export default __webpack_public_path__ + "static/media/passantenligplaatsen.466e5560.svg";